<template>
	<div class="inner-page new-case">

		<div v-if="thisCase.status != 'archive'">

			<Placeholder
				v-if="actualProgressStage == 5"
				message="You can no longer view this stage."
				:withBackButton="true"
				/>

			<template v-else>
				<AppHead title="Enquiry Submission" />

				<PageHeader 
					title="Enquiry Submission"
					desc="Upload required documents"
					:hasButton="false"
					:showHelper="true"
					helpTitle="Upload required documents"
					helpDesc="Please download and complete the enquiry form, then upload it on this page."
					/>

				<CaseProgressBar 
					:step="thisCase.progress_stage" 
					:thisCase="thisCase"
					:pageStep="0"
					/>

				<div class="new-case-form">
					
					<InputGroup
						title="1. Required Files"
						desc="Please download the relevant enquiry form from the available enquiry forms and complete it."
						>
						<div class="file-downloads" v-if="enquiryForms && enquiryForms.length > 0">
							<ButtonDownload
								v-for="(form, index) of enquiryForms"
								:key="index"
								:label="form.nice_name ? form.nice_name : form.file_name"
								icon="file-pdf"
								:file="form"
								/>
						</div>
						<ButtonDownload
							v-else
							:file="[]"
							emptyText="Download relevant enquiry form from the Document Library: CTBI (cage-based lower limb implant), CTS (custom talus spacer) or CULI (custom upper limb implant)."
							/>
						


					</InputGroup>


					<InputGroup
						title="2. Upload Your Enquiry"
						desc="Please upload your completed enquiry form"
						>
						<UploadBox 
							:case="thisCase" 
							designation="enquiry"
							@done="uploadingFinished"
							:maxFiles="30"
							/>
					</InputGroup>

					<div 
						class="existing-enquiries"
						v-if="enquiries && enquiries.length > 0"
						>

						<InputGroup
							title="Existing Enquiry Files"
							desc="These enquiries have already been uploaded to the case. If you need to upload more, please do so above."
							>

							<div class="file-list" v-if="enquiries.length > 0">
								<FileBox
									v-for="(enquiry, index) in enquiries"
									:key="index"
									:file="enquiry"
									:canDownload="true"
									/>
							</div>

						</InputGroup>

					</div>


					<InputGroup
						title=""
						desc=""
						:skipWhiteBox="true"
						:noLine="true"
						:oneColumn="true"
						class="button-group"
						>
						<Button
							label="Next"
							color="green"
							size="large"
							icon="save" 
							@click="submit"
							:disabled="!isFormComplete"
							/>
						<Button
							v-if="thisCase.progress_stage > 0"
							label="Back"
							color="white"
							size="large"
							icon="times"
							push="left"
							:buttonRoute="`/cases/${thisCase.hashid}`"
							/>
					</InputGroup>

				</div>
			
			</template>
		</div>
    <Placeholder
      v-else
      message="This case has been archived. You can no longer edit it."
			:withBackButton="true"
      />

	</div>
</template>

<script>

import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import Button from "@/Components/Button"
import ButtonDownload from "@/Components/ButtonDownload"
import InputGroup from "@/Components/InputGroup"
import CaseProgressBar from "@/Components/Cases/CaseProgressBar"
import UploadBox from "@/Components/Upload/UploadBox"
import InputTextarea from "@/Components/InputTextarea"
import Placeholder from "@/Components/Placeholder"
import Subtitle from "@/Components/Subtitle"
import FileBox from "@/Components/Cases/FileBox"

export default {
	props: [
		'thisCase',
		'enquiryForms',
		'enquiries'
	],
	components: {
		AppLayout,
		AppHead,
		PageHeader,
		Button,
		ButtonDownload,
		InputGroup,
		CaseProgressBar,
		UploadBox,
		InputTextarea,
		Placeholder,
		Subtitle,
		FileBox
	},
	layout: AppLayout,
	data: () => {
		return {
			isFormComplete: false
		}
	},
	methods: {
		submit(){
			if(this.isFormComplete){
				this.$inertia.post(`/cases/${this.thisCase.hashid}/upload-enquiry`)
			}
		},
		uploadingFinished(){
			this.isFormComplete = true
		}
	},
	computed: {
		actualProgressStage(){
			if(this.thisCase.override_progress !== null){
				return this.thisCase.override_progress
			}else{
				return this.thisCase.progress_stage
			}
		}
	}
};

</script>

<style lang="sass">

.new-case
	.new-case-form
		padding-top: 30px

	.file-downloads
		display: flex
		flex-direction: column
		gap: 15px

	.existing-enquiries
		margin-bottom: 40px
		
		.file-list
			margin-bottom: 30px
			width: 100%
			display: flex
			flex-direction: column
			gap: 10px

	.button-group
		.input-block
			@media (max-width: 768px)
				display: flex
				flex-direction: column
				gap: 10px

				.button
					margin: 0
					width: 100%

				a
					display: flex
					width: 100%

</style>